var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"timeline-container",on:{"click":_vm.goToTime}},[_c('vue-slider',{attrs:{"min":0,"max":_vm.videoDuration,"contained":true,"height":6,"drag-on-click":true,"width":"100%","tooltip":'none',"processStyle":{
                background: _vm.skin.controls.color
            },"dotStyle":{
                background: _vm.skin.controls.color
            },"railStyle":{
                background: 'rgba(0, 0, 0, 0.4)'
            }},on:{"change":_vm.playerSeek},model:{value:(_vm.videoTime),callback:function ($$v) {_vm.videoTime=$$v},expression:"videoTime"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }